<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="580px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="set-allocation-dialog">
      <div class="allocation-selected-box">
        <label>{{ $t('message["1477"]') }}:</label>
        <div class="allocation-list">
          <span
            v-for="(item, index) in selectedDatas"
            :key="item.id"
          >
            {{ item.fieldname }}
            <i
              class="iconfont iconicon-test5"
              @click="delItem(item,index)"
            />
          </span>
        </div>
        <div class="allocation-all-box">
          <span
            v-for="(item) in datas"
            :key="item.fieldkey"
            :class="{'selected': item.isSelected }"
            @click="addRule(item)"
          >
            {{ item.fieldname }}
            <i class="iconfont icontest93" />
          </span>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['allDatas', 'selectedDatas']),
    ...mapGetters('config/allocationrule', ['datas']),
    ids () {
      const { selectedDatas } = this
      return selectedDatas.map(item => item.id)
    },
    modalTit () {
      return this.$t('message["303"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('config/allocationrule', ['setAllocationForm']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    async formHandle () {
      const chain = await this.setAllocationForm()
      chain.params({ ids: this.ids })
        .onSuccess(raw => {
          this.isLimitDialogShow = false
          this.$message.success(this.$t('message["1023"]') + '！')
        })
        .fetch()
    },
    delItem (item, index) {
      this.selectedDatas.splice(index, 1)
      this.datas.forEach((ele) => {
        if (item.fieldkey === ele.fieldkey) {
          // ele.isSelected = false
          this.$set(ele, 'isSelected', false)
        }
      })
    },
    addRule (item) {
      const { selectedDatas } = this
      if (!item.isSelected) {
        this.$set(item, 'isSelected', false)
        selectedDatas.push(item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .allocation-selected-box {
    padding-left: 72px;
    position: relative;
    label {
      position: absolute;
      left: 0;
      color: #666;
    }
    .allocation-list {
      margin-bottom: 12px;
      padding-bottom: 12px;
      border-bottom: 1px solid #d7d7d7;
      line-height: 32px;
      span{
        display:inline-block;
        height: 30px;
        line-height: 30px;
        background:rgba(80,119,170,0.65);
        border-radius:4px;
        border:1px solid rgba(80,119,170,1);
        padding: 0 8px;
        color: #fff;
        margin:0 12px 12px 0;
        i{
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
    .allocation-all-box {
      span{
        display:inline-block;
        height: 30px;
        line-height: 30px;
        background:#fff;
        border-radius:4px;
        border:1px solid #ccc;
        padding: 0 8px 0;
        margin:12px 12px 0 0;
        i{
          font-size: 12px;
          cursor: pointer;
          visibility:hidden;
        }
      }
      .selected {
        color:#5077AA;
        border-color: #5077AA;
        i {
          visibility:visible;
        }
      }
    }
 }
</style>
